// Detect if string contains "+ or -" from a start
export default str => /^[+-]\d/g.test(str);
